import { FC } from 'react';

import { Alert, AlertDescription, AlertIcon, AlertStatus, CloseButton } from '@bonusly/design-system';

export type ToastStatus = Extract<AlertStatus, 'success' | 'info' | 'error'>;

export interface ToastProps {
	isCloseable?: boolean;
	message: string;
	onClose?: VoidFunction;
	status?: ToastStatus;
}

const statusColor = (status: ToastStatus) => {
	const color = {
		info: 'blue',
		success: 'green',
		error: 'red',
	}[status];

	return (value: string | number) => `${color}.${value}`;
};

export const Toast: FC<ToastProps> = ({ isCloseable, message, onClose, status = 'info' }) => {
	const color = statusColor(status);

	return (
		<Alert alignItems="center" status={status} boxShadow="md">
			<AlertIcon color={color(700)} />
			<AlertDescription color={color(700)} flex={1} fontWeight="medium">
				{message}
			</AlertDescription>
			{isCloseable && (
				<CloseButton
					backgroundColor={color('highlight10')}
					borderRadius="full"
					color={color(800)}
					ml={2}
					onClick={onClose}
					_active={{
						backgroundColor: color('highlight20'),
					}}
					_hover={{
						backgroundColor: color('highlight20'),
					}}
				/>
			)}
		</Alert>
	);
};
